import Modal from "@material-ui/core/Modal";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { centerModal } from "src/util";

const styles = (theme: Theme) => ({
  modal: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 3,
    boxShadow: theme.shadows[5],
    height: "30em",
    maxHeight: "100%",
    maxWidth: "100%",
    overflow: "auto",
    padding: 20,
    width: "30em",
    ...centerModal,
  },
});

export interface IModalProps {
  open: boolean;
  closeModal: () => void;
  className?: any;
}

type IModalPropsWithStyles = IModalProps & {
  children: React.ReactNode;
} & WithStyles<keyof ReturnType<typeof styles>>;

const MyModal: React.SFC<IModalPropsWithStyles> = ({
  children,
  classes,
  open,
  closeModal,
  className,
}: IModalPropsWithStyles) => (
  <Modal open={open} onClose={closeModal}>
    <div className={`${className} ${classes.modal}`}>{children}</div>
  </Modal>
);

// TODO: Fix TypeScript flagged issue
// @ts-ignore
export default withStyles(styles)(MyModal);



// WEBPACK FOOTER //
// ./src/shared/components/Modal.tsx